<template>
  <div id="tab-msc">
    <div style="width: fit-content">
      <div style="display: flex">
        <!--订舱信息-->
        <div class="section form-column" style="width: 400px;height: 300px">
          <el-form :disabled="readonly" label-width="112px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.BookingInfo')">{{ $t('SeaExport.BookingInfo') }}</span>
            <el-form-item label="MST Booking">
              <el-input v-model="mscData.mstBooking" no="mstBooking" style="width: 200px" />
            </el-form-item>
            <el-form-item label="ContractRateMode">
              <el-select
                v-model="mscData.contractRateMode"
                no="contractRateMode"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
                clearable
                style="width: 200px"
              >
                <el-option
                  v-for="(item,index) in SystemConstants.CONTRACT_RATE_MODE_LIST"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>

            </el-form-item>
            <el-form-item label="">
              <div style="display: flex">
                <el-checkbox v-model="mscData.freightBl" no="freightBl" label="Freight BL" />
                <el-checkbox v-model="mscData.podAgency" no="podAgency" label="POD Agency" />
              </div>
            </el-form-item>
          </el-form>
        </div>
        <!--运输信息-->
        <div class="section form-column" style="width: 420px;height: 300px">
          <el-form :disabled="readonly" label-width="180px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.TransportInfo')">{{ $t('SeaExport.TransportInfo') }}</span>
            <el-form-item label="Place0fReceiptCY">
              <el-input v-model="mscData.place0fReceiptCy" no="place0fReceiptCy" style="width: 200px" />
            </el-form-item>
            <el-form-item label="Place0fReceiptShippingMode">
              <el-select
                v-model="mscData.place0fReceiptShippingMode"
                no="place0fReceiptShippingMode"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
                clearable
                style="width: 200px"
              >
                <el-option
                  v-for="(item,index) in transportationModeInfos"
                  :key="index"
                  :label="item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="Final Dest">
              <cargo-advance-select
                no="finalDest"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="mscData.finalDest"
                tag-name="englishName"
                style="width: 200px"
                @parentCallBack="p=>{ mscData.finalDest = p.value }"
              />
            </el-form-item>
            <el-form-item label="FNL SubLoc">
              <el-input v-model="mscData.fnlSubLoc" no="fnlSubLoc" style="width: 200px" />
            </el-form-item>
            <el-form-item label="FNL TM">
              <el-input v-model="mscData.fnlTm" no="fnlTm" style="width: 200px" />
            </el-form-item>
            <el-form-item label="Comment">
              <el-input v-model="mscData.comment" no="comment" style="width: 200px" />
            </el-form-item>
            <el-form-item label="Destination Zip Code">
              <el-input v-model="mscData.destinationZipCode" no="destinationZipCode" style="width: 200px" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div
        class="section"
        style="width: 1800px"
      >
        <span class="title" :title="$t('SeaExport.ConsigneeShipperAndNotifyInfo')">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1)}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{
                $t('SeaExport.CodeSearching')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{
                $t('SeaExport.CopyFromTheLastTime')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{
                $t('SeaExport.CopyFromOtherBill')
              }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="form-row" style="display:flex;flex-direction:row;margin-top:8px">
          <!--          发货人-->
          <el-form
            label-width="120px"
            label-position="right"
            style="margin-right:10px"
          >
            <el-form-item
              :label="$t('SeaExport.Shipper')"
            />
            <el-form-item label="VIP CODE">
              <cargo-input v-model="mscData.shipperVipCode" :disabled="readonly" no="shipperVipCode" style="width: 220px;" />
            </el-form-item>
            <el-form-item label="MSC CODE">
              <cargo-input v-model="mscData.shipperMscCode" :disabled="readonly" no="shipperMscCode" />
            </el-form-item>
            <el-form-item label="COMPANY CODE">
              <cargo-input v-model="mscData.shipperCompanyCode" :disabled="readonly" no="shipperCompanyCode" />
            </el-form-item>
            <el-form-item label="INTTRA CODE">
              <cargo-input v-model="mscData.shipperInttraCode" :disabled="readonly" no="shipperInttraCode" />
            </el-form-item>
            <el-form-item label="Other Info">
              <cargo-input v-model="mscData.shipperOtherInfo" :disabled="readonly" no="shipperOtherInfo" />
            </el-form-item>
            <el-form-item label="Use BL">
              <el-checkbox v-model="mscData.shipperUseBl" :disabled="readonly" no="shipperUseBl" label=" " @change="useBlChange(1)" />
            </el-form-item>
            <el-form-item v-show="mscData.shipperUseBl" label="BL Company">
              <cargo-input v-model="mscData.shipperBlCompany" :disabled="readonly" no="shipperBlCompany" />
            </el-form-item>
            <el-form-item v-show="mscData.shipperUseBl" label="BL Address">
              <cargo-input v-model="mscData.shipperBlAddress" :disabled="readonly" no="shipperBlAddress" />
            </el-form-item>
            <el-form-item v-show="mscData.shipperUseBl" label="BL Contact">
              <cargo-input v-model="mscData.shipperBlContact" :disabled="readonly" no="shipperBlContact" />
            </el-form-item>
          </el-form>
          <!--          收货人-->
          <el-form
            label-width="120px"
            label-position="right"
            style="margin-right:20px"
          >
            <el-form-item
              :label="$t('SeaExport.Consignee')"
            />
            <el-form-item label="VIP CODE">
              <cargo-input v-model="mscData.consigneeVipCode" :disabled="readonly" no="consigneeVipCode" style="width: 220px;" />
            </el-form-item>
            <el-form-item label="MSC CODE">
              <cargo-input v-model="mscData.consigneeMscCode" :disabled="readonly" no="consigneeMscCode" />
            </el-form-item>
            <el-form-item label="COMPANY CODE">
              <cargo-input v-model="mscData.consigneeCompanyCode" :disabled="readonly" no="consigneeCompanyCode" />
            </el-form-item>
            <el-form-item label="INTTRA CODE">
              <cargo-input v-model="mscData.consigneeInttraCode" :disabled="readonly" no="consigneeInttraCode" />
            </el-form-item>
            <el-form-item label="Other Info">
              <cargo-input v-model="mscData.consigneeOtherInfo" :disabled="readonly" no="consigneeOtherInfo" />
            </el-form-item>
            <el-form-item label="Use BL">
              <el-checkbox v-model="mscData.consigneeUseBl" :disabled="readonly" no="consigneeUseBl" label=" " @change="useBlChange(2)" />
            </el-form-item>
            <el-form-item v-show="mscData.consigneeUseBl" label="BL Company">
              <cargo-input v-model="mscData.consigneeBlCompany" :disabled="readonly" no="consigneeBlCompany" />
            </el-form-item>
            <el-form-item v-show="mscData.consigneeUseBl" label="BL Address">
              <cargo-input v-model="mscData.consigneeBlAddress" :disabled="readonly" no="consigneeBlAddress" />
            </el-form-item>
            <el-form-item v-show="mscData.consigneeUseBl" label="BL Contact">
              <cargo-input v-model="mscData.consigneeBlContact" :disabled="readonly" no="consigneeBlContact" />
            </el-form-item>
          </el-form>
          <!--          通知人-->
          <el-form
            label-width="120px"
            label-position="right"
            style="margin-right:20px"
          >
            <el-form-item
              :label="$t('SeaExport.NotifyParty')"
            />
            <el-form-item label="VIP CODE">
              <cargo-input v-model="mscData.notifyVipCode" :disabled="readonly" no="notifyVipCode" style="width: 220px;" />
            </el-form-item>
            <el-form-item label="MSC CODE">
              <cargo-input v-model="mscData.notifyMscCode" :disabled="readonly" no="notifyMscCode" />
            </el-form-item>
            <el-form-item label="COMPANY CODE">
              <cargo-input v-model="mscData.notifyCompanyCode" :disabled="readonly" no="notifyCompanyCode" />
            </el-form-item>
            <el-form-item label="INTTRA CODE">
              <cargo-input v-model="mscData.notifyInttraCode" :disabled="readonly" no="notifyInttraCode" />
            </el-form-item>
            <el-form-item label="Other Info">
              <cargo-input v-model="mscData.notifyOtherInfo" :disabled="readonly" no="notifyOtherInfo" />
            </el-form-item>
            <el-form-item label="Use BL">
              <el-checkbox v-model="mscData.notifyUseBl" :disabled="readonly" no="notifyUseBl" label=" " @change="useBlChange(3)" />
            </el-form-item>
            <el-form-item v-show="mscData.notifyUseBl" label="BL Company">
              <cargo-input v-model="mscData.notifyBlCompany" :disabled="readonly" no="notifyBlCompany" />
            </el-form-item>
            <el-form-item v-show="mscData.notifyUseBl" label="BL Address">
              <cargo-input v-model="mscData.notifyBlAddress" :disabled="readonly" no="notifyBlAddress" />
            </el-form-item>
            <el-form-item v-show="mscData.notifyUseBl" label="BL Contact">
              <cargo-input v-model="mscData.notifyBlContact" :disabled="readonly" no="notifyBlContact" />
            </el-form-item>
          </el-form>
        </div>
        <div class="form-row" style="display:flex;flex-direction:row;margin-top:8px">
          <!--also notify-->
          <el-form
            label-width="120px"
            label-position="right"
            style="margin-right:10px"
          >
            <el-form-item
              label-width="0"
              :label="' '"
            >
              <div style="display: flex;">
                <el-select
                  v-model="mscData.alsoNotifyCode"
                  :disabled="readonly"
                  no="alsoNotifyCode"
                  style="width: 120px;"
                >
                  <el-option
                    v-for="(item,index) in otherFieldsData"
                    :key="index"
                    :label="item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="VIP CODE">
              <cargo-input v-model="mscData.alsoNotifyVipCode" :disabled="readonly" no="alsoNotifyVipCode" style="width: 220px;" />
            </el-form-item>
            <el-form-item label="MSC CODE">
              <cargo-input v-model="mscData.alsoNotifyMscCode" :disabled="readonly" no="alsoNotifyMscCode" />
            </el-form-item>
            <el-form-item label="COMPANY CODE">
              <cargo-input v-model="mscData.alsoNotifyCompanyCode" :disabled="readonly" no="alsoNotifyCompanyCode" />
            </el-form-item>
            <el-form-item label="INTTRA CODE">
              <cargo-input v-model="mscData.alsoNotifyInttraCode" :disabled="readonly" no="alsoNotifyInttraCode" />
            </el-form-item>
            <el-form-item label="Other Info">
              <cargo-input v-model="mscData.alsoNotifyOtherInfo" :disabled="readonly" no="alsoNotifyOtherInfo" />
            </el-form-item>
            <el-form-item label="Use BL">
              <el-checkbox v-model="mscData.alsoNotifyUseBl" :disabled="readonly" no="alsoNotifyUseBl" label=" " @change="useBlChange(4)" />
            </el-form-item>
            <el-form-item v-show="mscData.alsoNotifyUseBl" label="BL Company">
              <cargo-input v-model="mscData.alsoNotifyBlCompany" :disabled="readonly" no="alsoNotifyBlCompany" />
            </el-form-item>
            <el-form-item v-show="mscData.alsoNotifyUseBl" label="BL Address">
              <cargo-input v-model="mscData.alsoNotifyBlAddress" :disabled="readonly" no="alsoNotifyBlAddress" />
            </el-form-item>
            <el-form-item v-show="mscData.alsoNotifyUseBl" label="BL Contact">
              <cargo-input v-model="mscData.alsoNotifyBlContact" :disabled="readonly" no="alsoNotifyBlContact" />
            </el-form-item>
          </el-form>
          <!--付款方-->
          <el-form
            label-width="120px"
            label-position="right"
            style="margin-right:20px"
          >
            <el-form-item
              :label="$t('CargoMsg.Cargo_Payment1')"
            >
              <div style="display: flex;width: 100%">
                <el-input
                  v-model="mscData.paymentCode"
                  :disabled="readonly"
                  no="paymentCode"
                  style="width: 150px"
                />
                <el-button
                  no="BringInData"
                  type="primary"
                  style="margin-left: 5px"
                  :disabled="readonly "
                  @click="paymentImportData(true)"
                >{{ $t('CargoMsg.Cargo_BringInData') }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="VIP CODE">
              <cargo-input v-model="mscData.paymentVipCode" :disabled="readonly" no="paymentVipCode" />
            </el-form-item>
            <el-form-item label="MSC CODE">
              <cargo-input v-model="mscData.paymentMscCode" :disabled="readonly" no="paymentMscCode" />
            </el-form-item>
            <el-form-item label="COMPANY CODE">
              <cargo-input v-model="mscData.paymentCompanyCode" :disabled="readonly" no="paymentCompanyCode" />
            </el-form-item>
            <el-form-item label="INTTRA CODE">
              <cargo-input v-model="mscData.paymentInttraCode" :disabled="readonly" no="paymentInttraCode" />
            </el-form-item>
            <el-form-item label="Other Info">
              <cargo-input v-model="mscData.paymentOtherInfo" :disabled="readonly" no="paymentOtherInfo" />
            </el-form-item>
            <el-form-item label="Use BL">
              <el-checkbox v-model="mscData.paymentUseBl" :disabled="readonly" no="paymentUseBl" label=" " @change="useBlChange(5)" />
            </el-form-item>
            <el-form-item v-show="mscData.paymentUseBl" label="BL Company">
              <cargo-input v-model="mscData.paymentBlCompany" :disabled="readonly" no="paymentBlCompany" />
            </el-form-item>
            <el-form-item v-show="mscData.paymentUseBl" label="BL Address">
              <cargo-input v-model="mscData.paymentBlAddress" :disabled="readonly" no="paymentBlAddress" />
            </el-form-item>
            <el-form-item v-show="mscData.paymentUseBl" label="BL Contact">
              <cargo-input v-model="mscData.paymentBlContact" :disabled="readonly" no="paymentBlContact" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :params="billAddressDialog.params"
      :job="job"
      :show-payment="true"
      @callback="p => {codeSearchCallback(p, true)}"
    />
    <!-- 工作单检索弹窗 -->
    <msc-search-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="p=>{selectionItemHandler(p)}"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import { MscSupplement } from '@/class/model/booking/MscSupplement'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import cargoInput from '@/components/Cargo/Common/cargoInput.vue'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip.vue'
import { Company } from '@/class/model/mdm/Company'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { Job } from '@/class/model/booking/Job'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import mscSearchDialog from '@/components/Cargo/Job/mscSearchDialog.vue'

export default {
  name: 'TabMscBookingInfo',
  components: {
    specialCharacterTip, cargoInput, cargoCompanySelect,
    cargoAdvanceSelect,
    CargoRichTextarea,
    billAddressDialog,
    AutoNumberInput,
    mscSearchDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    showButton: { // 显示关联业务进来为false
      type: Boolean,
      default: true
    },
    paramData: {
      type: Object,
      default: null
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      SystemConstants,
      URL,
      isZh: this.$store.getters.language === 'zh',
      mscData: new MscSupplement().fillDefaultValue().getData(),
      job: new Job().fillDefaultValue().getData(),
      otherFieldsData: [SeaExportConstants.ALSO_NOTIFY],
      transportationModeInfos: [],
      command1: this.$t('SeaExport.CodeSearching'),
      selectTypeNames: TYPE_NAMES,
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false,
      billAddressDialog: {
        visible: false,
        params: {}
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    }
  },
  watch: {
    paramData(newVal, oldVal) {
      if (newVal) {
        this.paramDataChange(newVal)
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(cache.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
  },
  methods: {
    async onShow(row, isRefresh) {
      await cache.load(cacheName.CONFIG)
      this.job = row
      await this.fillView()
    },
    async fillView() {
      await new MscSupplement(this.job).getMscSupplement()
      if (!this.job.mscSupplement) {
        this.job.mscSupplement = new MscSupplement().fillDefaultValue().getData()
      }
      this.mscData = this.job.mscSupplement
      JobUtils.getTransportationModeAll(this.job).then(res => {
        this.transportationModeInfos = res
      })
      if (!this.mscData.alsoNotifyCode) {
        this.mscData.alsoNotifyCode = SeaExportConstants.ALSO_NOTIFY.code
      }
    },
    getSubmitData() {
      const job = { ...this.job }
      const result = {
        job,
        mscSupplement: this.mscData
      }
      return result
    },
    executeTask() {
      DocCommon.MSC_History.shipperVipCode = this.mscData.shipperVipCode
      DocCommon.MSC_History.shipperMscCode = this.mscData.shipperMscCode
      DocCommon.MSC_History.shipperCompanyCode = this.mscData.shipperCompanyCode
      DocCommon.MSC_History.shipperInttraCode = this.mscData.shipperInttraCode
      DocCommon.MSC_History.shipperUseBl = this.mscData.shipperUseBl
      DocCommon.MSC_History.shipperBlCompany = this.mscData.shipperBlCompany
      DocCommon.MSC_History.shipperBlAddress = this.mscData.shipperBlAddress
      DocCommon.MSC_History.shipperBlContact = this.mscData.shipperBlContact

      DocCommon.MSC_History.consigneeVipCode = this.mscData.consigneeVipCode
      DocCommon.MSC_History.consigneeMscCode = this.mscData.consigneeMscCode
      DocCommon.MSC_History.consigneeCompanyCode = this.mscData.consigneeCompanyCode
      DocCommon.MSC_History.consigneeInttraCode = this.mscData.consigneeInttraCode
      DocCommon.MSC_History.consigneeUseBl = this.mscData.consigneeUseBl
      DocCommon.MSC_History.consigneeBlCompany = this.mscData.consigneeBlCompany
      DocCommon.MSC_History.consigneeBlAddress = this.mscData.consigneeBlAddress
      DocCommon.MSC_History.consigneeBlContact = this.mscData.consigneeBlContact

      DocCommon.MSC_History.notifyVipCode = this.mscData.notifyVipCode
      DocCommon.MSC_History.notifyMscCode = this.mscData.notifyMscCode
      DocCommon.MSC_History.notifyCompanyCode = this.mscData.notifyCompanyCode
      DocCommon.MSC_History.notifyInttraCode = this.mscData.notifyInttraCode
      DocCommon.MSC_History.notifyUseBl = this.mscData.notifyUseBl
      DocCommon.MSC_History.notifyBlCompany = this.mscData.notifyBlCompany
      DocCommon.MSC_History.notifyBlAddress = this.mscData.notifyBlAddress
      DocCommon.MSC_History.notifyBlContact = this.mscData.notifyBlContact

      DocCommon.MSC_History.alsoNotifyVipCode = this.mscData.alsoNotifyVipCode
      DocCommon.MSC_History.alsoNotifyMscCode = this.mscData.alsoNotifyMscCode
      DocCommon.MSC_History.alsoNotifyCompanyCode = this.mscData.alsoNotifyCompanyCode
      DocCommon.MSC_History.alsoNotifyInttraCode = this.mscData.alsoNotifyInttraCode
      DocCommon.MSC_History.alsoNotifyUseBl = this.mscData.alsoNotifyUseBl
      DocCommon.MSC_History.alsoNotifyBlCompany = this.mscData.alsoNotifyBlCompany
      DocCommon.MSC_History.alsoNotifyBlAddress = this.mscData.alsoNotifyBlAddress
      DocCommon.MSC_History.alsoNotifyBlContact = this.mscData.alsoNotifyBlContact

      DocCommon.MSC_History.paymentVipCode = this.mscData.paymentVipCode
      DocCommon.MSC_History.paymentMscCode = this.mscData.paymentMscCode
      DocCommon.MSC_History.paymentCompanyCode = this.mscData.paymentCompanyCode
      DocCommon.MSC_History.paymentInttraCode = this.mscData.paymentInttraCode
      DocCommon.MSC_History.paymentUseBl = this.mscData.paymentUseBl
      DocCommon.MSC_History.paymentBlCompany = this.mscData.paymentBlCompany
      DocCommon.MSC_History.paymentBlAddress = this.mscData.paymentBlAddress
      DocCommon.MSC_History.paymentBlContact = this.mscData.paymentBlContact
    },
    /**
     * 发货人选择
     */
    async shipperAutoCompleteChange(data, detail) {
      this.mscData.shipperId = data.value || 0
      if (data.value) {
        const company = new Company(data)
        await company.getMainfestAddress()
        CargoDocUtil.applyShipperManifestAddress(this.mscData, data, detail)
      } else {
        CargoDocUtil.onClear(this.mscData, 1, detail)
      }
    },
    async consigneeAutoCompleteChange(data, detail) {
      this.mscData.consigneeId = data.value || 0
      if (data.value) {
        const company = new Company(data)
        await company.getMainfestAddress()
        CargoDocUtil.applyConsigneeManifestAddress(this.mscData, data, detail)
      } else {
        CargoDocUtil.onClear(this.mscData, 2, detail)
      }
    },
    /**
     * 通知人选择
     */
    async notifyAutoCompleteChange(data, detail) {
      this.mscData.notifyId = data.value || 0
      if (data.value) {
        const company = new Company(data)
        await company.getMainfestAddress()
        CargoDocUtil.applyNotifyManifestAddress(this.mscData, data, detail)
      } else {
        CargoDocUtil.onClear(this.mscData, 3, detail)
      }
    },
    async paymentImportData(type) {
      CargoDocUtil.paymentImportData(this.mscData, type)
    },
    stringValue(value1, value2) {
      let value = value1 || ''
      if (value2) {
        value += ' ' + value2
      }
      return value.trim()
    },
    useBlChange(type) {
      let mbl = {}
      for (const doc of this.job.cargoDoc) {
        if (doc.docType === 'MBL') {
          mbl = doc
          break
        }
      }
      switch (type) {
        case 1:
          if (!this.mscData.shipperUseBl) {
            this.mscData.shipperBlCompany = ''
            this.mscData.shipperBlAddress = ''
            this.mscData.shipperBlContact = ''
          } else {
            this.mscData.shipperBlCompany = mbl.shipperLine1 || this.job.shipperLine1
            this.mscData.shipperBlAddress = this.stringValue(mbl.shipperLine2, mbl.shipperLine3) || this.stringValue(this.job.shipperLine2, this.job.shipperLine3)
            this.mscData.shipperBlContact = ''
          }
          break
        case 2:
          if (!this.mscData.consigneeUseBl) {
            this.mscData.consigneeBlCompany = ''
            this.mscData.consigneeBlAddress = ''
            this.mscData.consigneeBlContact = ''
          } else {
            this.mscData.consigneeBlCompany = mbl.consigneeLine1 || this.job.consigneeLine1
            this.mscData.consigneeBlAddress = this.stringValue(mbl.consigneeLine2, mbl.consigneeLine3) || this.stringValue(this.job.consigneeLine2, this.job.consigneeLine3)
            this.mscData.consigneeBlContact = ''
          }
          break
        case 3:
          if (!this.mscData.notifyUseBl) {
            this.mscData.notifyBlCompany = ''
            this.mscData.notifyBlAddress = ''
            this.mscData.notifyBlContact = ''
          } else {
            this.mscData.notifyBlCompany = mbl.notifyLine1 || this.job.notifyLine1
            this.mscData.notifyBlAddress = this.stringValue(mbl.notifyLine2, mbl.notifyLine3) || this.stringValue(this.job.notifyLine2, this.job.notifyLine3)
            this.mscData.notifyBlContact = ''
          }
          break
        case 4:
          if (!this.mscData.alsoNotifyUseBl) {
            this.mscData.alsoNotifyBlCompany = ''
            this.mscData.alsoNotifyBlAddress = ''
            this.mscData.alsoNotifyBlContact = ''
          } else {
            if (mbl.alsoNotify) {
              this.alsoNotifyBlContact(mbl)
            } else {
              this.alsoNotifyBlContact(this.job)
            }
          }
          break
        case 5:
          if (!this.mscData.paymentUseBl) {
            this.mscData.paymentBlCompany = ''
            this.mscData.paymentBlAddress = ''
            this.mscData.paymentBlContact = ''
          } else {
            this.mscData.paymentBlCompany = mbl.paymentLine1
            this.mscData.paymentBlAddress = this.stringValue(mbl.paymentLine2, mbl.paymentLine3)
            this.mscData.paymentBlContact = ''
          }
          break
      }
    },
    alsoNotifyBlContact(form) {
      if (form.alsoNotify) {
        const alsoData = form.alsoNotify.split('\r')
        if (alsoData.length > 0) {
          this.mscData.alsoNotifyBlCompany = alsoData[0]
        }
        if (alsoData.length > 1) {
          this.mscData.alsoNotifyBlAddress = this.stringValue(alsoData[1], alsoData[2])
        }
        if (alsoData.length > 2) {
          this.mscData.alsoNotifyBlContact = ''
        }
      }
    },
    onClear(form, type, detail) {
      switch (type) {
        case 1:
          form.shipperCode = ''
          form.shipperLine1 = ''
          form.shipperLine2 = ''
          form.shipperLine3 = ''
          if (detail) {
            form.shipperCountry = ''
            form.shipperCity = ''
            form.shipperProvince = ''
            form.shipperZipCode = ''
            form.shipperMobile = ''
            form.shipperEmail = ''
            form.shipperFax = ''
            form.shipperContact = ''
          } else {
            form.shipperLine4 = ''
            form.shipperLine5 = ''
            form.shipperLine6 = ''
            form.shipperLine7 = ''
          }
          break
        case 2:
          form.consigneeCode = ''
          form.consigneeLine1 = ''
          form.consigneeLine2 = ''
          form.consigneeLine3 = ''
          if (detail) {
            form.consigneeCountry = ''
            form.consigneeCity = ''
            form.consigneeProvince = ''
            form.consigneeZipCode = ''
            form.consigneeMobile = ''
            form.consigneeEmail = ''
            form.consigneeFax = ''
            form.consigneeContact = ''
          } else {
            form.consigneeLine4 = ''
            form.consigneeLine5 = ''
            form.consigneeLine6 = ''
            form.consigneeLine7 = ''
          }
          break
        case 3:
          form.notifyCode = ''
          form.notifyLine1 = ''
          form.notifyLine2 = ''
          form.notifyLine3 = ''
          if (detail) {
            form.notifyCountry = ''
            form.notifyCity = ''
            form.notifyProvince = ''
            form.notifyZipCode = ''
            form.notifyMobile = ''
            form.notifyEmail = ''
            form.notifyFax = ''
            form.notifyContact = ''
          } else {
            form.notifyLine4 = ''
            form.notifyLine5 = ''
            form.notifyLine6 = ''
            form.notifyLine7 = ''
          }
          break
        default:
          break
      }
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.params.isPortFilter = false
          this.billAddressDialog.params.shipperCode = this.mscData.shipperCode
          this.billAddressDialog.params.consigneeCode = this.mscData.consigneeCode
          this.billAddressDialog.params.notifyCode = this.mscData.notifyCode
          this.billAddressDialog.params.shipperField = 'shipperCode'
          this.billAddressDialog.params.consigneeField = 'consigneeCode'
          this.billAddressDialog.params.notifyField = 'notifyCode'
          this.billAddressDialog.params.mbl = true
          this.billAddressDialog.visible = true
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'MSC',
            selectType: 'single',
            job: this.job
          })
          this.searchBillNoDialog.visible = true
          break
      }
    },
    onCopy1() {
      this.mscData.shipperVipCode = DocCommon.MSC_History.shipperVipCode || ''
      this.mscData.shipperMscCode = DocCommon.MSC_History.shipperMscCode || ''
      this.mscData.shipperCompanyCode = DocCommon.MSC_History.shipperCompanyCode || ''
      this.mscData.shipperInttraCode = DocCommon.MSC_History.shipperInttraCode || ''
      this.mscData.shipperUseBl = DocCommon.MSC_History.shipperUseBl || false
      this.mscData.shipperBlCompany = DocCommon.MSC_History.shipperBlCompany || ''
      this.mscData.shipperBlAddress = DocCommon.MSC_History.shipperBlAddress || ''
      this.mscData.shipperBlContact = DocCommon.MSC_History.shipperBlContact || ''
      this.mscData.consigneeVipCode = DocCommon.MSC_History.consigneeVipCode || ''
      this.mscData.consigneeMscCode = DocCommon.MSC_History.consigneeMscCode || ''
      this.mscData.consigneeCompanyCode = DocCommon.MSC_History.consigneeCompanyCode || ''
      this.mscData.consigneeInttraCode = DocCommon.MSC_History.consigneeInttraCode || ''
      this.mscData.consigneeUseBl = DocCommon.MSC_History.consigneeUseBl || false
      this.mscData.consigneeBlCompany = DocCommon.MSC_History.consigneeBlCompany || ''
      this.mscData.consigneeBlAddress = DocCommon.MSC_History.consigneeBlAddress || ''
      this.mscData.consigneeBlContact = DocCommon.MSC_History.consigneeBlContact || ''
      this.mscData.notifyVipCode = DocCommon.MSC_History.notifyVipCode || ''
      this.mscData.notifyMscCode = DocCommon.MSC_History.notifyMscCode || ''
      this.mscData.notifyCompanyCode = DocCommon.MSC_History.notifyCompanyCode || ''
      this.mscData.notifyInttraCode = DocCommon.MSC_History.notifyInttraCode || ''
      this.mscData.notifyUseBl = DocCommon.MSC_History.notifyUseBl || false
      this.mscData.notifyBlCompany = DocCommon.MSC_History.notifyBlCompany || ''
      this.mscData.notifyBlAddress = DocCommon.MSC_History.notifyBlAddress || ''
      this.mscData.notifyBlContact = DocCommon.MSC_History.notifyBlContact || ''
      this.mscData.alsoNotifyVipCode = DocCommon.MSC_History.alsoNotifyVipCode || ''
      this.mscData.alsoNotifyMscCode = DocCommon.MSC_History.alsoNotifyMscCode || ''
      this.mscData.alsoNotifyCompanyCode = DocCommon.MSC_History.alsoNotifyCompanyCode || ''
      this.mscData.alsoNotifyInttraCode = DocCommon.MSC_History.alsoNotifyInttraCode || ''
      this.mscData.alsoNotifyUseBl = DocCommon.MSC_History.alsoNotifyUseBl || false
      this.mscData.alsoNotifyBlCompany = DocCommon.MSC_History.alsoNotifyBlCompany || ''
      this.mscData.alsoNotifyBlAddress = DocCommon.MSC_History.alsoNotifyBlAddress || ''
      this.mscData.alsoNotifyBlContact = DocCommon.MSC_History.alsoNotifyBlContact || ''
      this.mscData.paymentVipCode = DocCommon.MSC_History.paymentVipCode || ''
      this.mscData.paymentMscCode = DocCommon.MSC_History.paymentMscCode || ''
      this.mscData.paymentCompanyCode = DocCommon.MSC_History.paymentCompanyCode || ''
      this.mscData.paymentInttraCode = DocCommon.MSC_History.paymentInttraCode || ''
      this.mscData.paymentUseBl = DocCommon.MSC_History.paymentUseBl || false
      this.mscData.paymentBlCompany = DocCommon.MSC_History.paymentBlCompany || ''
      this.mscData.paymentBlAddress = DocCommon.MSC_History.paymentBlAddress || ''
      this.mscData.paymentBlContact = DocCommon.MSC_History.paymentBlContact || ''
    },
    paramDataChange(newVal) {
      this.codeSearchCallback(newVal, false)
    },
    codeSearchCallback(data, override) {
      const fields = [
        { key: 'shipperVipCode', infoKey: 'shipperInfo' },
        { key: 'shipperMscCode', infoKey: 'shipperInfo' },
        { key: 'shipperCompanyCode', infoKey: 'shipperInfo' },
        { key: 'shipperInttraCode', infoKey: 'shipperInfo' },
        { key: 'consigneeVipCode', infoKey: 'consigneeInfo' },
        { key: 'consigneeMscCode', infoKey: 'consigneeInfo' },
        { key: 'consigneeCompanyCode', infoKey: 'consigneeInfo' },
        { key: 'consigneeInttraCode', infoKey: 'consigneeInfo' },
        { key: 'notifyVipCode', infoKey: 'notifyInfo' },
        { key: 'notifyMscCode', infoKey: 'notifyInfo' },
        { key: 'notifyCompanyCode', infoKey: 'notifyInfo' },
        { key: 'notifyInttraCode', infoKey: 'notifyInfo' },
        { key: 'paymentVipCode', infoKey: 'paymentInfo' },
        { key: 'paymentMscCode', infoKey: 'paymentInfo' },
        { key: 'paymentCompanyCode', infoKey: 'paymentInfo' },
        { key: 'paymentInttraCode', infoKey: 'paymentInfo' }
      ]
      fields.forEach(field => {
        const { key, infoKey } = field
        if (data[infoKey]) {
          if (!this.mscData[key] || override) {
            this.mscData[key] = data[key]
          }
        }
      })
    },
    selectionItemHandler(p) {
      const fields = [
        { key: 'shipperVipCode' },
        { key: 'shipperMscCode' },
        { key: 'shipperCompanyCode' },
        { key: 'shipperInttraCode' },
        { key: 'shipperUseBl' },
        { key: 'shipperBlCompany' },
        { key: 'shipperBlAddress' },
        { key: 'shipperBlContact' },
        { key: 'consigneeVipCode' },
        { key: 'consigneeMscCode' },
        { key: 'consigneeCompanyCode' },
        { key: 'consigneeInttraCode' },
        { key: 'consigneeUseBl' },
        { key: 'consigneeBlCompany' },
        { key: 'consigneeBlAddress' },
        { key: 'consigneeBlContact' },
        { key: 'notifyVipCode' },
        { key: 'notifyMscCode' },
        { key: 'notifyCompanyCode' },
        { key: 'notifyInttraCode' },
        { key: 'notifyUseBl' },
        { key: 'notifyBlCompany' },
        { key: 'notifyBlAddress' },
        { key: 'notifyBlContact' },
        { key: 'paymentVipCode' },
        { key: 'paymentMscCode' },
        { key: 'paymentCompanyCode' },
        { key: 'paymentInttraCode' },
        { key: 'paymentUseBl' },
        { key: 'paymentBlCompany' },
        { key: 'paymentBlAddress' },
        { key: 'paymentBlContact' }
      ]
      fields.forEach(field => {
        this.mscData[field.key] = p[field.key]
      })
    }
  }
}
</script>

<style lang="scss">
</style>
